export enum OktaStoreEnum {
  CACHE = 'CACHE',
  LOCALSTORAGE = 'LOCALSTORAGE'
}
